import actionTypes from './actionTypes';
import questionAPI from './questionAPI';

const questionActions = {
	getQuestions: () => {
		return (dispatch: any) => {
			return questionAPI.getQuestions()
			.then(questions => {
				dispatch({type: actionTypes.FETCH_QUESTION_SUCCESS, questions});
			});
		};
	},
};

export default questionActions;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/questionActions.ts